import { userService } from "../services";
import config from "../config/config";

export const SiteAction = {
  fetchSiteList,
  addSiteAccess,
  removeSiteAccess,
  removeGeofench,
  fetchSiteRouteSubSite,
  fetchSiteCategoryType,
  fetchLandmarksByMines,
};

async function fetchSiteList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.SiteList}?companyId=${
      payload.companyId
    }&status=${payload.status ? payload.status : ""}&userId=${
      JSON.parse(sessionStorage.getItem("data")).id
    }&showSubSite=${
      payload.showSubSite == "false" ? false : true
    }&siteCategory=${payload.siteCategory ? payload.siteCategory : ""}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchSiteCategoryType(showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.siteCategoryType}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchSiteRouteSubSite(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${
      config.apiName.routeSiteSubSite
    }?companyId=${payload.companyId}&showRoute=${payload.showRoute}&userId=${
      JSON.parse(sessionStorage.getItem("data")).id
    }&showSubSite=${payload.showSubSite}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeGeofench(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${
      config.apiName.removeGeoFench
    }?companyId=${payload.companyId}&siteId=${
      payload.siteId ? payload.siteId : ""
    }&userId=${JSON.parse(sessionStorage.getItem("data")).id}&subSiteId=${
      payload.subSiteId ? payload.subSiteId : ""
    }&remarks=${payload.remarks}&docUrl=${payload.fileUrl} `;

    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function addSiteAccess(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddSiteAccess}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeSiteAccess(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.RemoveSiteAccess}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchLandmarksByMines(payload, showSnackbar) {
  try {
    const mineIds = payload.mineIds?.join(",");

    let apiEndpoint = `${config.baseUrl}${
      config.apiName.landmarkByMines
    }?mineIds=${mineIds}`;

    let response = await userService.get(apiEndpoint);

    console.log("Landmark Response", response);

    if (response && response.status == 200) {
      return response.data;
    } else {
      showSnackbar(response?.data?.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    showSnackbar("Failed to fetch landmarks", "error");
    return null;
  }
}
